import { Message } from "./Message";


export class Notes {
  constructor(vesselNotesArr) {
    this.vesselNotesArr = vesselNotesArr;
    this.reactObj = (<>
      {this.vesselNotesArr.map((vesselEntry) => vesselEntry.reactObj)}
    </>);
  }

  static fromJson(jsonObj) {
    let notes = [];
    for (let vessel in jsonObj["Notes"]) {
      let vesselObj = VesselNotes.fromJson(vessel, jsonObj["Notes"][vessel]);
      notes.push(vesselObj);
    }
    return new Notes(notes);
  }
}

export class VesselNotes {
  constructor(name, messages) {
    this.name = name;
    this.messages = messages;
    this.reactObj = (<div className="log-section" key={ name }>
      <h2>{this.name}</h2>
      <div className="section-messages">
        {this.messages.length === 0 ?
          <p>No messages found.</p>
          :
          (<>{this.messages.map((message) => message.reactObj)}</>)}
      </div>
    </div>);
  }

  toJson() {
    let ret = {[this.name]: []}
    for (let ind in this.messages) {
      ret[this.name].push(this.messages[ind].toJson());
    }
    return ret;
  }

  static fromJson(name, jsonMessages) {
    return new VesselNotes(name, Message.messagesFromJson(jsonMessages));
  }
}
